import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './views/App';
import createStore from './store';

/* eslint-disable */
const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

window.fbAsyncInit = function() {
	FB.init({
	  appId: '516245735848059',
	  autoLogAppEvents: true,
	  xfbml: true,
	  version: 'v6.0'
	});
};
/* eslint-enable */
const customMiddleware = [];

if (process.env.NODE_ENV === `development`) {
  // eslint-disable-next-line
  const logger = require(`redux-logger`).createLogger({
    collapsed: true,
  });

  customMiddleware.push(logger);
}

const store = createStore(preloadedState, customMiddleware);

const basename = process.env.API_ENV !== 'staging' ? '/' : '/staging/quickscope/';

ReactDOM.hydrate(
  <Provider store={store}>
    <Router basename={basename}>
      <App />
    </Router>
  </Provider>,
  document.getElementById(`root`),
);

/* eslint-disable */
//load the FB SDK asynchronously
(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) { return; }
  js = d.createElement(s); js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

/* eslint-enable */
